// The modules behind the shell slots (slots.tsx), found with import.meta.glob so a slot file that does not exist yet
// simply renders the fallback instead of breaking the build.
import type { ComponentType } from 'react'

// Slot modules have different props; each call site narrows the type through SlotProps.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AnyComponent = ComponentType<any>

export const slotModules = import.meta.glob<{ default: AnyComponent }>([
  '/src/features/chat/components/ChatPopover.tsx',
  '/src/features/notifications/components/NotificationsPopover.tsx',
  '/src/features/notifications/components/LevelUpToast.tsx',
  '/src/features/shortcuts/ShortcutsProvider.tsx',
  '/src/features/billing/components/BillingBanner.tsx',
  '/src/features/billing/components/CheckoutSuccessWatcher.tsx',
  '/src/features/communities/components/CommunitySidebar.tsx',
  '/src/features/communities/components/CommunityHeaderCard.tsx',
  '/src/features/*/slots/*.tsx',
  // A test next to a slot would otherwise become a production chunk (with the test libraries in it).
  '!/src/features/*/slots/*.test.tsx',
])
